import { ABILITY_TOKEN } from '@casl/vue';

export default {
 inject:{
    $abillity: { from: ABILITY_TOKEN }
 }    
}
